import { Paper, Stack, Typography } from "@mui/material";

const CustomGraphTooltip = ({ active, payload, label, yName }) => {
  if (active && payload && payload.length) {
    return (
      <Paper
        width={"102px"}
        sx={{ p: 2, borderRadius: "15px", border: "1px solid rgba(0,0,0,0.2)" }}
      >
        <Stack spacing={2}>
          <Typography fontWeight={"bold"} fontSize={"12px"}>
            {label}
          </Typography>
          <Typography
            fontWeight={"bold"}
            fontSize={"12px"}
          >{`${yName}: ${payload?.[0]?.payload?.yValue}${payload?.[0]?.unit}`}</Typography>
        </Stack>
      </Paper>
    );
  }

  return null;
};
export default CustomGraphTooltip;
